var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormRender',{attrs:{"form":_vm.form,"Service":_vm.Service}},[_c('FormSwitch',{attrs:{"field":_vm.formFields.is_disable_all_push},model:{value:(_vm.form.is_disable_all_push),callback:function ($$v) {_vm.$set(_vm.form, "is_disable_all_push", $$v)},expression:"form.is_disable_all_push"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }